module.exports = __webpack_public_path__ + "media/reskin-images/icon--star2-e56cf18e.svg";